'use client';

import { UserContext } from '@/contexts/UserContext';
import { User } from '@/components/Types';

export default function ClientUserProvider({
  children,
  user,
}: {
  children: React.ReactNode;
  user: User | null;
}) {
  return (
    <UserContext.Provider value={user}>
      {children}
    </UserContext.Provider>
  );
}